function openForm(id) {
  const form = window.document.getElementById(id);
  if (form) { form.style.display = 'block'; }
}

function closeForms() {
  const forms = window.document.querySelectorAll('.booking-widget .table-form');
  forms.forEach((form) => {
    form.style.display = 'none';
  });
}

function preSelectPropertyInBookingWidget(element) {
  const wrapper = element.closest('.location');
  const buttons = wrapper.querySelectorAll('.location__button');
  const properties = window.document.querySelectorAll('.js-table-selected');

  buttons.forEach((button) => {
    const buttonLink = button.getAttribute('href');
    properties.forEach((property) => {
      const dataProperty = property.dataset.property;
      const dataValue = property.dataset.value;
      if (buttonLink.includes(dataProperty)) {
        property.click();
        closeForms();
        openForm(`table-${dataValue}`);
      }
    });
  });
}

const buttons = window.document.querySelectorAll('.location__button');
buttons.forEach((item) => {
  item.addEventListener('click', () => {
    preSelectPropertyInBookingWidget(item);
  });
});
